import { buildUrl } from '../../../utils/api';

export const fetchSiteURL = (id: string) => buildUrl(`/api/v3/adm/site/${id}`);
